<template>
    <div class="container-fluid" id="app">

      <!-- Wrap whole app in instant search so hits and credentials are available to all components  -->
      <ais-instant-search
        :search-client="searchClient"
        index-name="ct_live_products"
      >
      <Main/>
      </ais-instant-search>
    <vue-headful :url="'https://cherrytree.co.nz/c2' + $route.path" />
    </div>
</template>

<script>
import Main from "./pageTemplates/View_Main"
import algoliasearch from 'algoliasearch/lite';
import { AisInstantSearch} from 'vue-instantsearch';


const algoliaClient = algoliasearch(
  '0QZTOCOVM6',
  '5c9a70249d12da80d66e3141d21b8884'
);

export default {
  name: 'app',
  components:{
    Main,
    AisInstantSearch
  },
  data(){
    return{
      //setup search client
      searchClient: {
        
        search(requests) {
          if (requests.every(({ params }) => params.query.length < 2)) {
            //if there is no query, return no results and don't do search
            return Promise.resolve({
              results: requests.map(() => ({
                hits: [],
                nbHits: 0,
                nbPages: 0,
                processingTimeMS: 0,
              })),
            });
          }
          return algoliaClient.search(requests);
        },
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
